import { __decorate } from "tslib";
// NPM
import { Component, Vue } from "vue-property-decorator";
import { Guid } from "guid-typescript";
import { setInteractionMode } from "vee-validate";
setInteractionMode("passive");
// QUINLAN
import Layout from "../../layouts/auth.vue";
import { AuthModule } from "../../../store/modules/auth.module";
import { SettingModule } from "../../../store/modules/settings.module"; // settings module
import { NotificationsModule } from "../../../store/modules/notification.module";
import { UserLoginModel } from "@/store/models/userLoginAnalytics/userLogin";
import { VUE_APP_WSC_SERVICE_ID } from "@/services/config";
let TenantGateway = /** @class */ (() => {
    let TenantGateway = class TenantGateway extends Vue {
        constructor() {
            super(...arguments);
            this.pageIsLoading = true;
            this.isAccessDenied = false;
            this.tenant = { id: null, name: "", isUserAssigned: false };
            this.userLoginDetails = new UserLoginModel();
        }
        chooseTenant() {
            this.validate().then((response) => {
                if (response) {
                    SettingModule.AssignSelectedTenant(this.tenant);
                    NotificationsModule.GetNotificationCount(this.tenant.id.toString()).then((response) => { });
                    SettingModule.GetUserProfile();
                    SettingModule.GetUserRights().then((response) => {
                        const isFreshLogin = localStorage.getItem("IsFreshLogin");
                        if (isFreshLogin && isFreshLogin == "true") {
                            this.saveUserLoginDetails();
                            localStorage.removeItem("IsFreshLogin");
                        }
                        const redirectRoute = localStorage.getItem("TenantGatewayRedirectRoute");
                        if (redirectRoute && redirectRoute != "/") {
                            this.$router.push(redirectRoute);
                        }
                        else {
                            this.$router.push({ name: "DashBoard" });
                        }
                    });
                }
            });
        }
        async saveUserLoginDetails() {
            this.userLoginDetails.tenantId = this.tenant.id.toString();
            await AuthModule.SaveUserLoginDetails(this.userLoginDetails);
        }
        backToSignIn() {
            AuthModule.Logout();
        }
        get tenants() {
            return SettingModule.tenants.filter((x) => x.isUserAssigned == true);
        }
        validate() {
            let form = this.$refs.observer;
            return form.validate().then((valid) => {
                if (this.tenant.id.toString() == Guid.parse(Guid.EMPTY).toString()) {
                    return false;
                }
                else {
                    return true;
                }
            });
        }
        mounted() {
            const script = document.createElement("script");
            script.src = "https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js";
            script.type = "text/javascript";
            script.async = true;
            document.body.appendChild(script);
            // Initialize the WebSpellChecker configuration
            window.WEBSPELLCHECKER_CONFIG = {
                autoSearch: true,
                serviceId: VUE_APP_WSC_SERVICE_ID,
            };
        }
        created() {
            this.tenant = {
                id: Guid.parse(Guid.EMPTY),
                name: "Select",
                isUserAssigned: false,
            };
            SettingModule.FindUserRole().then((roleResponse) => {
                if (roleResponse.isTenantAdmin == true || roleResponse.isClientUser == true) {
                    this.isAccessDenied = false;
                    SettingModule.GetTenants().then((response) => {
                        if (response.some((c) => c.isUserAssigned)) {
                            this.pageIsLoading = false;
                            if (this.tenants.length == 1) {
                                this.tenant = this.tenants[0];
                                this.chooseTenant();
                            }
                            else {
                                this.tenants.splice(0, 0, this.tenant);
                            }
                        }
                        else {
                            localStorage.clear();
                            this.pageIsLoading = false;
                            this.isAccessDenied = true;
                        }
                    });
                }
                else {
                    this.pageIsLoading = false;
                    this.isAccessDenied = true;
                }
            });
        }
    };
    TenantGateway = __decorate([
        Component({
            name: "TenantGateway",
            components: {
                Layout,
            },
        })
    ], TenantGateway);
    return TenantGateway;
})();
export default TenantGateway;
